import { Injectable } from '@angular/core';
import { State, Action, Selector, StateContext } from '@ngxs/store';
import { catchError, map, take } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { Error, CustomHttpErrorResponse, NotificationService } from '../../../../../../common';
import {
  Sc3FailedTransactionMessageInitialState,
  Sc3FailedTransactionMessageLoad,
} from './sc3-failed-transaction-message.actions';
import { Sc3FailedTransactionMessageService } from './sc3-failed-transaction-message.service';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface Sc3FailedTransactionMessageStateModel {
  sc3FailedTransactionMessage: string;
  loaded: boolean;
}

const initialState: Sc3FailedTransactionMessageStateModel = {
  sc3FailedTransactionMessage: null,
  loaded: false,
};

@State<Sc3FailedTransactionMessageStateModel>({
  name: 'sc3FailedTransactionMessage',
  defaults: initialState,
})
@Injectable()
export class Sc3FailedTransactionMessageState {
  constructor(
    private sc3FailedTransactionMessageService: Sc3FailedTransactionMessageService,
    private notificationService: NotificationService,
  ) {}

  @Selector()
  static getState(state: Sc3FailedTransactionMessageStateModel): Sc3FailedTransactionMessageStateModel {
    return state;
  }
  @Selector()
  static getSc3FailedTransactionMessage(state: Sc3FailedTransactionMessageStateModel): string {
    return state.sc3FailedTransactionMessage;
  }
  @Selector()
  static getLoaded(state: Sc3FailedTransactionMessageStateModel): boolean {
    return state.loaded;
  }

  @Action(Sc3FailedTransactionMessageLoad)
  getSc3FailedTransactionMessage(
    ctx: StateContext<Sc3FailedTransactionMessageStateModel>,
    { payload }: Sc3FailedTransactionMessageLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.sc3FailedTransactionMessageService.getSc3FailedTransactionMessage(payload).pipe(
      take(1),
      map((sc3FailedTransactionMessage: string) => {
        ctx.patchState({ sc3FailedTransactionMessage, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(Sc3FailedTransactionMessageInitialState)
  setInitialState(ctx: StateContext<Sc3FailedTransactionMessageStateModel>): void {
    ctx.setState(initialState);
  }
}
